import { TextField, TextFieldProps } from '@mui/material'
import React, { InputHTMLAttributes, useMemo } from 'react' // Import MUI TextField component
import { useField } from 'formik' // Import formik hook
import dayjs from 'dayjs' // Import date handlers

interface SelectDateWrapperProps extends InputHTMLAttributes<HTMLInputElement> {
  maxDate?: string
  name: string
}

const defaultMaxDate = dayjs().add(20, 'year').format('YYYY-MM-DD')

const SelectDateWrapper: React.FC<SelectDateWrapperProps & TextFieldProps> = ({
  maxDate = defaultMaxDate,
  name,
  ...otherProps
}) => {
  const [field, meta] = useField(name)

  const configSelectDate = useMemo(() => {
    const config = {
      ...field,
      ...otherProps,
      fullWidth: true,
      InputLabelProps: {
        shrink: true,
      },
      inputProps: {
        max: maxDate,
      },
      type: 'date',
      value: field.value || '',
      variant: 'outlined',
    }

    if (meta && meta.touched && meta.error) {
      return {
        ...config,
        error: true,
        helperText: meta.error,
      } as TextFieldProps
    }

    return config as TextFieldProps
  }, [field, maxDate, meta, otherProps])

  return <TextField {...configSelectDate} />
}

export default SelectDateWrapper
